<template>
  <TablePaginated
      label="Riddles Average Duration (m:s)"
      sublabel="What riddles have the highest average watched duration?"
      :main-list="itemData"
      :is-global-percent="isGlobalPercent"
      :value-formatter="formatDuration"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import TablePaginated from '../../../TablePaginated.vue';

export default {
  name: 'PagedListRiddlesAverage',
  components: {
    TablePaginated,
  },

  props: {
    itemData: {
      type: [Array],
      default() {
        return ([]);
      },
    },
  },

  computed: {
    ...mapGetters({
      isGlobalPercent: 'metrics/isGlobalPercent',
    }),
  },

  methods: {
    formatDuration(value) {
      return this.$numberManagement.secondsToMinSecFormat(value);
    },
  },
};
</script>
